import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { Text } from '../../Text/Text';
import type { TextProps } from '../../Text/Text';
import { useTitleWhenTruncated } from '../hooks/useTitleWhenTruncated';

const OptionLabelRoot = styled(Text)<{ $selected?: boolean }>`
    color: ${(props) => (props.$selected ? theme.colors.accent.foreground : 'inherit')};
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

type OptionLabelProps = TextProps & {
    $selected?: boolean;
    label: string;
};

export const OptionLabel = ({ label, ...props }: OptionLabelProps) => {
    const { ref, title } = useTitleWhenTruncated<HTMLSpanElement>(label);

    return (
        <OptionLabelRoot ref={ref} title={title} {...props}>
            {label}
        </OptionLabelRoot>
    );
};
